import { AssetFilesTable } from "components";

const AssetFiles = () => {

    return (
        <AssetFilesTable />
    );

}
export default AssetFiles;